import React, { useRef, useEffect, useContext } from 'react'
import { Grid, Card, Box, Tooltip } from '@material-ui/core'
import { components } from 'cng-web-lib'
import { useFormContext, useWatch } from 'react-hook-form'
import { ACEOceanTranslationContext } from '../../contexts/ACEOceanTranslationContext'
import CngSection from 'src/components/cngcomponents/CngSection'
import DGgoodsDetailsFormProperties from '../DGgoodsDetailsFormProperties'

const { button: { CngIconButton } } = components

const { initialValues } = DGgoodsDetailsFormProperties.formikProps

function DangerousGoodsSection() {
    const { getValues, setValue } = useFormContext()
    const { getTranslatedText } = useContext(ACEOceanTranslationContext)

    const dangerousGoods = useWatch({ name: 'dangerousGoods' })
    const lastIndex = useRef(dangerousGoods.length)

    function handleAddDGInfo(data) {
        const dangerousGoods = [...getValues('dangerousGoods'), { ...data, _id: ++lastIndex.current }]
        setValue('dangerousGoods', dangerousGoods)
    }

    function handleDeleteDGInfo(data) {
        const dangerousGoods = [...getValues('dangerousGoods')].filter((obj) =>
            obj.id ? obj.id !== data.id : obj._id !== data._id
        )
        setValue('dangerousGoods', dangerousGoods)
    }

    return (
        <Grid item xs={12}>
            <Grid container spacing={2}>
                {dangerousGoods.map((data, index) => (
                    <Grid key={index} item xs={12}>
                        <Card variant='outlined'>
                            <Box padding={2}>
                                <Grid container justify='space-between' spacing={1}>
                                    <Grid item xs={12}>
                                        <DGgoodsDetailsFormProperties.Fields index={index} />
                                    </Grid>

                                    <Grid item xs='auto'>
                                        <Grid container spacing={1}>
                                            <Grid item>
                                                <Tooltip placement='bottom' title='Add'>
                                                    <span>
                                                        <CngIconButton
                                                            icon={['fal', 'plus']} size='small' type='outlined'
                                                            onClick={() => handleAddDGInfo(initialValues)}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </Grid>

                                            <Grid item>
                                                <Tooltip placement='bottom' title='Clone'>
                                                    <span>
                                                        <CngIconButton
                                                            icon={['fal', 'copy']} size='small' type='outlined'
                                                            onClick={() => handleAddDGInfo({ ...data, id: undefined })}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </Grid>

                                            <Grid item>
                                                <Tooltip placement='bottom' title='Delete'>
                                                    <span>
                                                        <CngIconButton
                                                            icon={['fal', 'trash']} size='small' type='outlined'
                                                            onClick={() => handleDeleteDGInfo(data)}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )

}

export default DangerousGoodsSection